import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { type MenuItem } from '@/types/common';
import IcPlus from '@/assets/icons/Plus.svg?react';
import IcHamburger from '@/assets/icons/Hamburger.svg?react';
import styles from './MobileDock.module.scss';

interface MobileDockProps {
  primaryItems: MenuItem[];
  onOpenMore: () => void;
}

const MobileDock = ({ primaryItems, onOpenMore }: MobileDockProps) => {
  const { t } = useTranslation(['common']);

  // 2 tabs on the left of the FAB, then 1 tab + "More" on the right.
  const leftItems = primaryItems.slice(0, 2);
  const rightItems = primaryItems.slice(2, 3);

  const renderTab = (item: MenuItem) => {
    const Icon = item.icon;
    return (
      <NavLink
        key={item.label + item.href}
        to={item.href}
        end={!!item.submenuItems?.length}
        className={({ isActive }) =>
          classNames(styles.tab, { [styles.tabOn]: isActive })
        }
      >
        {Icon && <Icon className={styles.tabIcon} />}
        <span className={styles.tabLabel}>{t(item.label)}</span>
      </NavLink>
    );
  };

  return (
    <nav className={styles.dock} aria-label={t('common:menu.dashboard')}>
      {leftItems.map(renderTab)}
      <NavLink
        to="/signings/new"
        className={styles.fab}
        aria-label={t('common:menu.newSigningButton')}
      >
        <IcPlus className={styles.fabIcon} />
      </NavLink>
      {rightItems.map(renderTab)}
      <button
        type="button"
        className={styles.tab}
        onClick={onOpenMore}
        aria-label={t('common:menu.more')}
      >
        <IcHamburger className={styles.tabIcon} />
        <span className={styles.tabLabel}>{t('common:menu.more')}</span>
      </button>
    </nav>
  );
};

export default MobileDock;
